import { render } from "./AdminTenants.vue?vue&type=template&id=44b04e32"
import script from "./AdminTenants.vue?vue&type=script&lang=js"
export * from "./AdminTenants.vue?vue&type=script&lang=js"

import "./AdminTenants.vue?vue&type=style&index=0&id=44b04e32&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__